import superagent from 'superagent';
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {normalize, schema} from 'normalizr';

export const fetchSpecsheet = createAsyncThunk(
	'specsheet/get',
	(options, {getState}) =>
		superagent
			.get(`${getState().status.specsheetUrl}/int/${getState().status.lang}/specsheets.json`)
			.then((response) => JSON.parse(response.text))
			.catch((error) => error)
);

const specsheetInitialState = {
	status: 'idle',
	data: {
		specsheets: [],
	},
	error: {},
};
export const specsheetSlice = createSlice({
	name: 'specsheet',
	initialState: specsheetInitialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchSpecsheet.fulfilled, (state, action) => {
			if (action.payload && action.payload.length > 0) state.data.specsheets = action.payload;
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(fetchSpecsheet.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(fetchSpecsheet.rejected, (state, action) => {
			state.status = 'idle';
			state.error = {};
		});

	}
});


export const {} = specsheetSlice.actions;


export default specsheetSlice.reducer;
